<template>
    <ul class="navs">
        <li @click.stop="jumpOther('waybill')">
            <img src="@/assets/images/header/nav/nav-waybill-search.png" alt="运单查询" />
            运单查询
        </li>
        <li @click.stop="jumpOther('order')">
            <img src="@/assets/images/header/nav/nav-to-ship.png" alt="我要寄件" />
            我要寄件
        </li>
        <a :href="getDynamicURLWithContext('../store')">
            <img src="@/assets/images/header/nav/nav-store-query.png" alt="服务网点查询" />
            服务网点查询
        </a>
        <a :href="jumpToAgingInquire()">
            <img src="@/assets/images/header/nav/nav-price-query.png" alt="运费时效查询" />
            运费时效查询
        </a>
    </ul>
</template>

<script>
import { getDynamicURLWithContext } from '@/util/util'
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'
import { jump } from '@/mixins/pageJump/'

export default {
    name: 'Navs',
    methods: {
        getDynamicURLWithContext,
        jumpOther(type) {
            const urlConfig = {
                owfUrl: '/mobile/cn/sc/login',
                cxUrl: `${urls.MP_CHECK_TICKET}?type=${type === 'order' ? loginType.WX_ORDER : loginType.WX_QUERY}`
            }
            type === 'order' ? jump(urlConfig, true) : jump(urlConfig, true)
        },
        jumpToAgingInquire() {
            return urls.AGING_INQUIRE
        }
    }
}
</script>

<style lang="scss" scoped>
.navs {
    background: #d2001c;
    display: flex;
    align-items: center;
    li,
    a {
        padding: 32px 0;
        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 24px;
        font-weight: 400;
        color: #fff;
        img {
            width: 48px;
            height: auto;
            margin-bottom: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/components/navs.vue